














import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { vueCanvasPoster } from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
import QRCode from 'qrcode';
Vue.use(Popup).use(Button);
@Component({
  components: {
    vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  @Prop({ required: true }) url!: string;

  detailData: any = {};

  showCanvas = false;
  src = '';
  qrUrl = '';
  painting = {};

  getPainting() {
    QRCode.toDataURL(this.url, (err: any, url: string) => {
      if (err) {
        console.log('err occur:', err);
      } else {
        this.qrUrl = url;
      }
    });
    // 开始绘制
    this.painting = {
      width: '600px',
      height: '900px',
      background: '#f4f5f7',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/banner.jpg'),
          css: {
            top: '20px',
            left: '25px',
            width: '550px',
            height: '300px',
            mode: 'scaleToFill',
          },
        },
        // 分割线
        {
          type: 'rect',
          id: 'divider',
          css: {
            top: '320px',
            left: '25px',
            height: '1px',
            width: '550px',
            color: '#ccc',
          },
        },

        {
          type: 'image',
          url: this.qrUrl,
          css: {
            top: '500px',
            left: '200px',
            color: '#000',
            width: '200px',
            height: '200px',
          },
        },
        {
          type: 'text',
          text: '长按二维码保存海报',
          css: {
            top: '720px',
            left: '190px',
            color: '#000',
            fontSize: '24px',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
